/* Sofia's Spot — PDP layout tidy (Aug 2026).
   Moved out of an inline <script> in snippets/sofia-pdp-polish.liquid, which
   rendered twice per product page. Loaded once from cart-mini.liquid; every
   function no-ops on pages without the elements it looks for.
   All moves are node relocations — no markup is rewritten, so theme JS keeps
   working. */
(function () {
  if (window.__sofiaPdpLayout) return; window.__sofiaPdpLayout = true;

  function foldPrice() {
    var prices = document.querySelectorAll('[id="product-price"]');
    var aps = document.querySelectorAll('[id^="shopify-block-"][id*="afterpay" i]');
    var n = Math.min(prices.length, aps.length);
    for (var i = 0; i < n; i++) {
      var p = prices[i], a = aps[i];
      if (!p || !a || p.__sgFolded) continue;
      var row = document.createElement('div');
      row.className = 'sofia-price-row';
      p.parentNode.insertBefore(row, p);
      row.appendChild(p); row.appendChild(a);
      p.__sgFolded = true;
    }
  }

  function moveVariants() {
    var sw = document.querySelectorAll('.product__variants-swatches');
    var atc = document.querySelectorAll('.product__section--buttons .AddtoCart');
    var n = Math.min(sw.length, atc.length);
    for (var i = 0; i < n; i++) {
      if (!sw[i] || !atc[i] || sw[i].__sgMoved) continue;
      atc[i].parentNode.insertBefore(sw[i], atc[i]);
      sw[i].classList.add('sofia-variants');
      sw[i].__sgMoved = true;
    }
  }

  function pairQty() {
    var qtys = document.querySelectorAll('.product__section--qty');
    var atcs = document.querySelectorAll('.product__section--buttons .AddtoCart');
    var n = Math.min(qtys.length, atcs.length);
    for (var i = 0; i < n; i++) {
      var q = qtys[i], b = atcs[i];
      if (!q || !b || q.__sgPaired) continue;
      var row = document.createElement('div');
      row.className = 'sofia-buy-row';
      b.parentNode.insertBefore(row, b);
      row.appendChild(q); row.appendChild(b);
      q.__sgPaired = true;
    }
  }

  /* stock + pickup become one line under the trust panel. The
     <pickup-availability> ELEMENT is moved, never its children, so it can
     still re-render its own content on a variant change. */
  function mergeAvailability() {
    var trusts = document.querySelectorAll('.sofia-trust');
    var stocks = document.querySelectorAll('.product__section-stockLevels');
    var picks  = document.querySelectorAll('pickup-availability, .product-single__store-availability-container');
    for (var i = 0; i < trusts.length; i++) {
      var t = trusts[i];
      if (!t || t.__sgAvail) continue;
      var s = stocks[i], p = picks[i];
      if (!s && !p) continue;
      var row = document.createElement('div');
      row.className = 'sofia-avail';
      t.parentNode.insertBefore(row, t.nextSibling);
      if (s) row.appendChild(s);
      if (p) row.appendChild(p);
      t.__sgAvail = true;
    }
  }

  /* only lifts OUR bundle block, which renders on products carrying the
     custom.bundle_products metafield. Code Black Belt's block is untouched. */
  function liftBundle() {
    var all = document.querySelectorAll('.sofia-bundle');
    if (!all.length) return;
    var main = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
    if (!main) return;
    for (var i = 1; i < all.length; i++) { all[i].hidden = true; }
    var b = all[0];
    if (b.__sgLifted) return;
    var wrap = document.createElement('section');
    wrap.className = 'sofia-bundle-section';
    var eyebrow = document.createElement('p');
    eyebrow.className = 'sofia-bundle-section__eyebrow';
    eyebrow.textContent = 'How we style it';
    wrap.appendChild(eyebrow);
    main.parentNode.insertBefore(wrap, main.nextSibling);
    wrap.appendChild(b);
    b.__sgLifted = true;
  }

  function run() {
    if (!document.querySelector('.product__section--buttons')) return;
    try { foldPrice(); } catch (e) {}
    try { moveVariants(); } catch (e) {}
    try { pairQty(); } catch (e) {}
    try { mergeAvailability(); } catch (e) {}
    try { liftBundle(); } catch (e) {}
  }
  if (document.readyState !== 'loading') run();
  document.addEventListener('DOMContentLoaded', run);
  setTimeout(run, 600);
})();

/* Gift box ticks open the cart drawer (11 Oct 2026, Jessie: "yes" to the fix, built in the FOR CLAUDE copy for him to preview).
   A piece ticked in a product page gift bundle (sofia-giftbox) or curated gift bundle (sofia-curatedbox) went into the cart
   with the drawer shut, so a shopper who only ticked never saw the cart: 30 Sep to 10 Oct, 24 shoppers kept a ticked piece
   and 1 reached checkout (hub_docs 370). Now a tick that lands, or "Add the whole box", refreshes the drawer and opens it,
   as the product's own Add to cart does. Unticking never opens it. The boxes' own code is unchanged: this waits for the tile
   to reach "in" (the box's own added state), then queues the open behind the box's cart refresh (window.sofiaCartQueue). */
(function () {
  if (window.__sofiaTickDrawer) return; window.__sofiaTickDrawer = true;
  function cfg() { var el = document.getElementById('cart-config'); try { return JSON.parse((el && el.textContent) || '{}'); } catch (e) { return {}; } }
  function openDrawer() {
    var T = window.Shopify && Shopify.theme;
    if (!(T && T.cart && T.cart.getCart && T.ajaxCart && T.ajaxCart.updateView && T.ajaxCart.showDrawer)) return;
    var Q = window.sofiaCartQueue || function (task) { return Promise.resolve().then(task); };
    Q(function () { return T.cart.getCart(); }).then(function (cart) {
      var c = cfg(); T.ajaxCart.updateView(c, cart); T.ajaxCart.showDrawer(c);
    }).catch(function () {});
  }
  /* "in" = added: open. Not "on" any more = failed or unticked: stop. "need" = waiting for a size or scent: keep waiting. */
  function watch(opt) {
    if (!opt) return;
    var t0 = Date.now();
    function poll() {
      if (opt.classList.contains('in')) { setTimeout(openDrawer, 0); return; }
      if (!opt.classList.contains('on')) return;
      if (Date.now() - t0 > (opt.classList.contains('need') ? 120000 : 15000)) return;
      setTimeout(poll, 150);
    }
    setTimeout(poll, 60);
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.checked) return;
    if (t.matches('[data-cbx-pick]')) watch(t.closest('[data-cbx-opt]'));
    else if (t.matches('[data-sgb-pick]')) watch(t.closest('[data-sgb-opt]'));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-cbx-all]'); if (!btn) return;
    var box = btn.closest('[data-cbx]'); if (!box) return;
    var before = box.querySelectorAll('[data-cbx-opt].in').length, t0 = Date.now();
    function poll() {
      var busy = box.querySelector('[data-cbx-opt].busy');
      if (!busy && Date.now() - t0 > 400) {
        if (box.querySelectorAll('[data-cbx-opt].in').length > before) setTimeout(openDrawer, 0);
        return;
      }
      if (Date.now() - t0 > 15000) return;
      setTimeout(poll, 150);
    }
    setTimeout(poll, 60);
  });
})();
